import React from 'react'
import { Route } from 'react-router-dom'
import { auth } from '../../../services/util/auth.service'
import AtivoPatrimonial from './AtivoPatrimonial/AtivoPatrimonial'
import PatrimonioMenu from './PatrimonioMenu/PatrimonioMenu'
import MovimentacaoLastMile from './MovimentacaoLastMile/MovimentacaoLastMile'
import MovimentacaoRecebimento from './MovimentacaoRecebimento/MovimentacaoRecebimento'
import MovimentacaoDevolucao from './MovimentacaoDevolucao/MovimentacaoDevolucao'
import PrestacaoContaLastMile from './PrestacaoContaLastMile/PrestacaoContaLastMile'
import ValidacaoCanhoto from './ValidacaoCanhoto/ValidacaoCanhoto'
import PendenciasTransportadora from './PendenciasTransportadora/PendenciasTransportadora'
import SaldoPatrimonialPorOperacao from './SaldoPatrimonialPorOperacao/SaldoPatrimonialPorOperacao'
import UploadComprovanteRecebimento from './MovimentacaoRecebimento/UploadComprovante/UploadComprovante'
import UploadComprovanteDevolucao from './MovimentacaoDevolucao/UploadComprovante/UploadComprovante'
import UploadCanhoto from './ValidacaoCanhoto/UploadCanhoto/UploadCanhoto'

export default function Patrimonio() {
  return (
    <>
      <Route path="/main/patrimonio/menu" render={() => auth(<PatrimonioMenu />)} />
      <Route path="/main/patrimonio/ativo" render={() => auth(<AtivoPatrimonial />, 27)} />
      <Route
        path="/main/patrimonio/movimentacao-recebimento"
        render={() => auth(<MovimentacaoRecebimento />, 43)}
        exact
      />
      <Route
        path="/main/patrimonio/movimentacao-recebimento/upload-comprovante"
        render={() => auth(<UploadComprovanteRecebimento />, 43)}
      />
      <Route
        path="/main/patrimonio/movimentacao-devolução"
        render={() => auth(<MovimentacaoDevolucao />, 103)}
        exact
      />
      <Route
        path="/main/patrimonio/movimentacao-devolucao/upload-comprovante"
        render={() => auth(<UploadComprovanteDevolucao />, 103)}
      />
      <Route
        path="/main/patrimonio/movimentacao-last-mile"
        render={() => auth(<MovimentacaoLastMile />, 104)}
      />
      <Route
        path="/main/patrimonio/prestacao-contas"
        render={() => auth(<PrestacaoContaLastMile />, 104)}
      />
      <Route
        path="/main/patrimonio/validacao-canhoto"
        render={() => auth(<ValidacaoCanhoto />, 29)}
        exact
      />
      <Route
        path="/main/patrimonio/validacao-canhoto/upload-canhoto"
        render={() => auth(<UploadCanhoto />, 29)}
      />
      <Route
        path="/main/patrimonio/pendencias-transportadora"
        render={() => auth(<PendenciasTransportadora />, 106)}
      />
      <Route
        path="/main/patrimonio/saldo-por-operacao"
        render={() => auth(<SaldoPatrimonialPorOperacao />, 105)}
      />
    </>
  )
}
